<div>
    <r1-compass-lib-instructions headerText="Additional Fields">
        Define additional fields not in the Data Mart. First, assign each field a name. Then, select the source (static
        value or user input at the Play level). Then, select the data type. If the field is a Static value, provide the
        value to be used. Finally, check the box to make the field required.
    </r1-compass-lib-instructions>
    @for (group of formArray.controls; track $index; let rowIndex = $index) {
        <form [formGroup]="group">
            <r1-compass-lib-field-mapping
                [index]="$index"
                [totalRequiredRows]="0"
                [rowOptionButtons]="[
                    { value: 'addHelperText', display: 'Add helper text', show: true },
                    { value: 'delete', display: 'Delete', show: true },
                ]"
                (clickOption)="selectRowOption($index, group.value.id!, $event.value)">
                <div class="field-mapping-row">
                    <div class="field-mapping-container">
                        <div class="fieldType-toggle">
                            @switch (group.controls.source.value) {
                                @case ('Static') {
                                    <button mat-icon-button (click)="setRowSourceType('User', $index)" type="button">
                                        <fa-icon icon="pen" />
                                    </button>
                                }
                                @case ('User') {
                                    <button mat-icon-button (click)="setRowSourceType('Static', $index)" type="button">
                                        <fa-icon icon="user-pen" />
                                    </button>
                                }
                            }
                        </div>
                        <div class="field-mapping-content">
                            <mat-form-field class="field-mapping-form-field">
                                <mat-label>{{
                                    group.controls.source.value === 'Static' ? 'Static Field' : 'User Field'
                                }}</mat-label>
                                <input matInput formControlName="name" />
                                @if (group.controls.name.errors?.['nameTaken']) {
                                    <mat-error>Name is taken</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="field-mapping-content">
                            <mat-form-field class="field-mapping-form-field">
                                <mat-label>Data Type</mat-label>
                                <mat-select formControlName="type">
                                    @for (
                                        option of getDataTypeOptions(group.value.source);
                                        track idx;
                                        let idx = $index
                                    ) {
                                        <mat-option
                                            [value]="option.value"
                                            (click)="resetValueForm(rowIndex, option.value)"
                                            >{{ option.display }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        @switch (group.value.source) {
                            @case ('User') {
                                <div class="field-mapping-content">
                                    @switch (group.value.type) {
                                        @case ('picklist') {
                                            <button
                                                mat-icon-button
                                                (click)="
                                                    openPicklist(
                                                        $index,
                                                        group.getRawValue().picklistElements,
                                                        group.value.id!
                                                    )
                                                "
                                                type="button">
                                                <fa-icon icon="chart-tree-map" />
                                            </button>
                                        }
                                    }
                                </div>
                                <div class="field-mapping-content">
                                    <mat-checkbox formControlName="required">Required</mat-checkbox>
                                </div>
                            }
                            @case ('Static') {
                                <div class="field-mapping-content">
                                    @switch (group.value.type) {
                                        @case ('varchar') {
                                            <mat-form-field class="field-mapping-form-field">
                                                <mat-label>Value</mat-label>
                                                <input matInput formControlName="value" #d />
                                                @if (group.controls.value.errors?.['required']) {
                                                    <mat-error>Value required</mat-error>
                                                }
                                            </mat-form-field>
                                        }
                                        @case ('boolean') {
                                            <div class="boolean-toggle">
                                                <mat-button-toggle-group
                                                    formControlName="value"
                                                    name="value"
                                                    aria-label="Value"
                                                    [hideSingleSelectionIndicator]="true">
                                                    <mat-button-toggle [value]="'true'">True</mat-button-toggle>
                                                    <mat-button-toggle [value]="'false'">False</mat-button-toggle>
                                                </mat-button-toggle-group>
                                                @if (group.controls.value.errors?.['required']) {
                                                    <mat-error>Must pick a value</mat-error>
                                                }
                                            </div>
                                        }
                                        @case ('date') {
                                            <mat-form-field class="additional-fields-date field-mapping-form-field">
                                                <mat-label>Select a date</mat-label>
                                                <input
                                                    matInput
                                                    readonly
                                                    [matDatepicker]="datePicker"
                                                    formControlName="value"
                                                    (click)="datePicker.open()"
                                                    (dateInput)="onDateInput($event, $index)" />
                                                <fa-icon
                                                    matSuffix
                                                    class="additional-fields-date-icon"
                                                    [icon]="faCalendar"
                                                    (click)="datePicker.open()" />
                                                <mat-datepicker #datePicker />
                                                @if (group.controls.value.errors?.['required']) {
                                                    <mat-error>Value required</mat-error>
                                                }
                                            </mat-form-field>
                                        }
                                    }
                                </div>
                                <div class="field-mapping-content"></div>
                            }
                        }
                    </div>
                </div>
            </r1-compass-lib-field-mapping>
        </form>
    }
    <button mat-raised-button color="primary" (click)="addMapperRow()" type="button">+Add</button>
</div>
